/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegViaSmsReq } from '../../models/reg-via-sms-req';

export interface ApiUserRegisterSmsChallengePost$Params {
      body?: RegViaSmsReq
}

export function apiUserRegisterSmsChallengePost(http: HttpClient, rootUrl: string, params?: ApiUserRegisterSmsChallengePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiUserRegisterSmsChallengePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiUserRegisterSmsChallengePost.PATH = '/api/User/register-sms-challenge';
